import { mainSiteUrl } from '@/mocks/categories';
import { homepageSeoContent } from '@/mocks/seoContent';

export default function Hero() {
  const { heroTitle, heroSubtitle, ctaPrimary, ctaSecondary, trustBadges } = homepageSeoContent;

  return (
    <section className="relative w-full min-h-[90vh] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20dreamy%20abstract%20background%20with%20gentle%20flowing%20shapes%20in%20muted%20dusty%20rose%20and%20warm%20sand%20tones%2C%20subtle%20organic%20curves%20creating%20a%20calming%20atmosphere%2C%20very%20light%20watercolor%20texture%20effect%2C%20delicate%20pastel%20transitions%20from%20warm%20peach%20to%20pale%20oatmeal%2C%20airy%20spacious%20feel%2C%20no%20text%2C%20no%20hard%20edges%2C%20ethereal%20minimalist%20art&width=1600&height=900&seq=kakobuy-hero-bg-v2&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50/80" />

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-600 mb-6 whitespace-nowrap">
            <i className="ri-sparkling-line mr-1.5"></i>
            Updated for 2026
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-6">
            {heroTitle}
          </h1>

          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-10 leading-relaxed">
            {heroSubtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              {ctaPrimary}
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-400 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
            >
              {ctaSecondary}
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
            {trustBadges.map((badge, i) => (
              <span key={i} className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}